import { FileDown, FileSpreadsheet } from "lucide-react";
import { API } from "../lib/api";
import { toast } from "sonner";

/**
 * Exports a report via fetch with credentials, downloading as a file.
 * resource: financeiro|reservas|clientes|leads|precificacao
 */
export default function ExportButtons({ resource, label = "Exportar" }) {
  const download = async (fmt) => {
    try {
      const res = await fetch(`${API}/export/${resource}.${fmt}`, { credentials: "include" });
      if (!res.ok) throw new Error("Falha ao exportar");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `vm_${resource}.${fmt}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${fmt.toUpperCase()} gerado`);
    } catch (e) {
      toast.error("Erro ao exportar");
    }
  };
  return (
    <div className="inline-flex items-center gap-2" data-testid={`export-${resource}`}>
      <button onClick={() => download("pdf")} className="border border-[#14213D]/20 text-[#14213D] hover:bg-[#14213D] hover:text-white rounded-md px-3 py-1.5 text-xs font-semibold inline-flex items-center gap-1 transition" data-testid={`export-${resource}-pdf`}>
        <FileDown size={13} /> {label} PDF
      </button>
      <button onClick={() => download("xlsx")} className="border border-emerald-300 text-emerald-700 hover:bg-emerald-600 hover:text-white rounded-md px-3 py-1.5 text-xs font-semibold inline-flex items-center gap-1 transition" data-testid={`export-${resource}-xlsx`}>
        <FileSpreadsheet size={13} /> Excel
      </button>
    </div>
  );
}
